import {
  PictureOutlined,
  ReadOutlined,
  ShopOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

export const NOTIFICATION_ICONS = {
  Media: PictureOutlined,
  MarketplaceCatalogue: ShopOutlined,
  MPCategory: ShopOutlined,
  Offer: ShopOutlined,
  BackgroundTask: ShopOutlined,
  Category: ReadOutlined,
  Product: ReadOutlined,
  ProductTranslation: ReadOutlined,
};

export const hasNotificationError = (context = {}) =>
  Number(context.error_count) > 0 ||
  Number(context.lines_ko) > 0 ||
  context.status === 'en echec';

export const getNotificationIcon = (context = {}) => {
  if (hasNotificationError(context)) {
    return WarningOutlined;
  }
  return NOTIFICATION_ICONS[context.entity_type] || ReadOutlined;
};

export const getDateLabel = (date) => {
  const day = dayjs(date);
  if (day.isSame(dayjs(), 'day')) return "Aujourd'hui";
  if (day.isSame(dayjs().subtract(1, 'day'), 'day')) return 'Hier';
  return day.format('DD/MM/YYYY');
};
